"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_SLICES = void 0;
var alarm_1 = require("../features/apis/alarm");
var area_1 = require("../features/apis/area");
var area_library_1 = require("../features/apis/area-library");
var auth_1 = require("../features/apis/auth");
var client_1 = require("../features/apis/client");
var client_invitation_1 = require("../features/apis/client-invitation");
var device_1 = require("../features/apis/device");
var facility_1 = require("../features/apis/facility");
var file_1 = require("../features/apis/file");
var grow_cycle_1 = require("../features/apis/grow-cycle");
var grow_cycle_sop_1 = require("../features/apis/grow-cycle-sop");
var integration_1 = require("../features/apis/integration");
var notification_1 = require("../features/apis/notification");
var permission_1 = require("../features/apis/permission");
var seed_1 = require("../features/apis/seed");
var sop_library_1 = require("../features/apis/sop-library");
var task_1 = require("../features/apis/task");
var task_category_1 = require("../features/apis/task-category");
var user_1 = require("../features/apis/user");
exports.API_SLICES = [
    alarm_1.alarmApi,
    notification_1.notificationApi,
    auth_1.authApi,
    facility_1.facilityApi,
    grow_cycle_1.growCycleApi,
    grow_cycle_sop_1.growCycleSopApi,
    task_1.taskApi,
    user_1.userApi,
    permission_1.permissionApi,
    client_1.clientApi,
    client_invitation_1.clientInvitationApi,
    area_1.areaApi,
    device_1.deviceApi,
    sop_library_1.sopLibraryApi,
    seed_1.seedApi,
    area_library_1.areaLibraryApi,
    task_category_1.taskCategoryApi,
    integration_1.integrationApi,
    file_1.fileApi,
];
